<app-infolog></app-infolog>
<app-spinner></app-spinner>
<router-outlet></router-outlet>